"use strict";

var _objectSpread = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _objectWithoutProperties = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _regeneratorRuntime = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Block = void 0;

var lisk_codec_1 = require("@liskhq/lisk-codec");

var codec_1 = require("./codec");

var Block = /*#__PURE__*/function () {
  function Block(channel, registeredSchema) {
    _classCallCheck(this, Block);

    this._channel = channel;
    this._schemas = registeredSchema;
  }

  _createClass(Block, [{
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(id) {
        var idString, blockHex, blockBytes;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                idString = Buffer.isBuffer(id) ? id.toString('hex') : id;
                _context.next = 3;
                return this._channel.invoke('app:getBlockByID', {
                  id: idString
                });

              case 3:
                blockHex = _context.sent;
                blockBytes = Buffer.from(blockHex, 'hex');
                return _context.abrupt("return", codec_1.decodeBlock(blockBytes, this._schemas));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function get(_x) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "getByHeight",
    value: function () {
      var _getByHeight = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(height) {
        var blockHex, blockBytes;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._channel.invoke('app:getBlockByHeight', {
                  height: height
                });

              case 2:
                blockHex = _context2.sent;
                blockBytes = Buffer.from(blockHex, 'hex');
                return _context2.abrupt("return", codec_1.decodeBlock(blockBytes, this._schemas));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getByHeight(_x2) {
        return _getByHeight.apply(this, arguments);
      }

      return getByHeight;
    }()
  }, {
    key: "encode",
    value: function encode(input) {
      return codec_1.encodeBlock(input, this._schemas);
    }
  }, {
    key: "decode",
    value: function decode(input) {
      var inputBuffer = Buffer.isBuffer(input) ? input : Buffer.from(input, 'hex');
      return codec_1.decodeBlock(inputBuffer, this._schemas);
    }
  }, {
    key: "toJSON",
    value: function toJSON(block) {
      var _block$header = block.header,
          asset = _block$header.asset,
          headerRoot = _objectWithoutProperties(_block$header, ["asset"]);

      var tmpBlockId = headerRoot.id;
      delete headerRoot.id;

      var header = _objectSpread({}, lisk_codec_1.codec.toJSON(this._schemas.blockHeader, headerRoot), {
        asset: {},
        id: tmpBlockId === null || tmpBlockId === void 0 ? void 0 : tmpBlockId.toString('hex')
      });

      var headerAssetJson = lisk_codec_1.codec.toJSON(this._schemas.blockHeadersAssets[block.header.version], asset);
      header.asset = headerAssetJson;
      var payload = [];

      var _iterator = _createForOfIteratorHelper(block.payload),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var tx = _step.value;

          var txAsset = tx.asset,
              txRoot = _objectWithoutProperties(tx, ["asset"]);

          var tmpId = txRoot.id;
          delete txRoot.id;
          var schemaAsset = codec_1.getTransactionAssetSchema(tx, this._schemas);
          var jsonTxAsset = lisk_codec_1.codec.toJSON(schemaAsset, txAsset);
          var jsonTxRoot = lisk_codec_1.codec.toJSON(this._schemas.transaction, txRoot);

          var jsonTx = _objectSpread({}, jsonTxRoot, {
            id: tmpId === null || tmpId === void 0 ? void 0 : tmpId.toString('hex'),
            asset: jsonTxAsset
          });

          payload.push(jsonTx);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return {
        header: header,
        payload: payload
      };
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(block) {
      var _block$header2 = block.header,
          asset = _block$header2.asset,
          headerRoot = _objectWithoutProperties(_block$header2, ["asset"]);

      var tmpBlockId = headerRoot.id ? Buffer.from(headerRoot.id, 'hex') : Buffer.alloc(0);
      delete headerRoot.id;

      var header = _objectSpread({}, lisk_codec_1.codec.fromJSON(this._schemas.blockHeader, headerRoot), {
        asset: {},
        id: tmpBlockId
      });

      var headerAssetJson = lisk_codec_1.codec.fromJSON(this._schemas.blockHeadersAssets[block.header.version], asset);
      header.asset = headerAssetJson;
      var payload = [];

      var _iterator2 = _createForOfIteratorHelper(block.payload),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var tx = _step2.value;

          var txAsset = tx.asset,
              txRoot = _objectWithoutProperties(tx, ["asset"]);

          var tmpId = txRoot.id ? Buffer.from(txRoot.id, 'hex') : Buffer.alloc(0);
          delete txRoot.id;
          var schemaAsset = codec_1.getTransactionAssetSchema(tx, this._schemas);
          var txAssetObject = lisk_codec_1.codec.fromJSON(schemaAsset, txAsset);
          var txRootObject = lisk_codec_1.codec.fromJSON(this._schemas.transaction, txRoot);

          var txObject = _objectSpread({}, txRootObject, {
            id: tmpId,
            asset: txAssetObject
          });

          payload.push(txObject);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return {
        header: header,
        payload: payload
      };
    }
  }]);

  return Block;
}();

exports.Block = Block;